"use client";

import { useTranslations } from "next-intl";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle,
} from "@/components/ui/empty";

export const UserOrdersEmpty = ({ description }: { description: string }) => {
  const t = useTranslations("orders");
  return (
    <Empty className="py-17.5">
      <EmptyHeader>
        <EmptyDescription className="text-base">
          <EmptyTitle className="text-base">{t("empty.notFound")}</EmptyTitle>
          {description}
        </EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
};
